import { PRODUCT_NAME_FULL } from "../../product-name";
import { ribbonDark, ribbonLight, ribbonMarkDeep } from "../../brand/wordmark";

/** The standalone Turquoise R for a deep surface: the console header without a business logo (#2110). */
export function RibbonMark({ decorative = false }: { decorative?: boolean }) {
  return <img src={ribbonMarkDeep} alt={decorative ? "" : PRODUCT_NAME_FULL} width={100} height={100} className="ribbon-mark" />;
}

/** Asset adapter only; the surrounding screen retains its layout, theme and action. */
export function Wordmark({ surface = "theme", large = false, decorative = false }: {
  surface?: "theme" | "deep" | "light";
  large?: boolean;
  decorative?: boolean;
}) {
  const className = `ribbon-wordmark${large ? " ribbon-wordmark--large" : ""}`;
  const alt = decorative ? "" : PRODUCT_NAME_FULL;
  return <>
    {surface !== "deep" && <img src={ribbonLight} alt={alt} width={300} height={100}
      className={`${className}${surface === "theme" ? " ribbon-wordmark--on-light" : ""}`} />}
    {surface !== "light" && <img src={ribbonDark} alt={alt} width={300} height={100}
      className={`${className}${surface === "theme" ? " ribbon-wordmark--on-dark" : ""}`} />}
  </>;
}
